<template>
  <div class="sr_trace_track">
    <SrTrace
      :trackData="trackData"
      :defaultProps="defaultProps"
      :imgUrl="imgUrl"
      :theme="theme"
      ref="sr_trace_track"
    ></SrTrace>

    <div class="traceTrackBtn"  @click="open">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SrTrace from "./SrTraceTrack.vue";
export default {
  name: "SrTraceTrack",
  components: {
    SrTrace,
  },
  data() {
    return {
      // 配置项
      defaultProps: {
        name: "name",
        value: "value",
        fileList: "fileList",
        list: "list",
      },
    };
  },
  props: {
    trackData: {
      type: Array,
      default() {
        return [];
      },
    },
    imgUrl: {
      type: String,
      default() {
        return "";
      },
    },
    theme: {
      type: String,
      default() {
        return "default";
      },
    },
  },
  methods: {
    open() {
      this.$refs.sr_trace_track.open();
    },
  },
};
</script>


// WEBPACK FOOTER //
// packages/SrTraceTrack/index.vue